import DealRedemptions from "./DealRedemptions";
export default DealRedemptions;
